import { apiRequest } from '../utils/useAPIRequest';
import constant from '../utils/constant';
import { adminStore, businessCategoryStore, expenseCategoryStore } from '../stores';
import { UseRequest } from '../utils/useAPIRequest';
import { capitalizeFirstLetter } from '../utils/utils';

const getExpenseCategories = async (query = "") => {
  const { status, errorMessage, data } = await apiRequest({
    url: `/banking/expense-categories?${query}`,
    method: 'get'
  });
  if (status === constant.Success) {  
    const { expenseCategories } = data || {};
    expenseCategoryStore.setExpenseCategory(expenseCategories);
    return { status }
  }
  return { status, errorMessage };
};

const createExpenseCategories = async (payload) => {
  const { status, errorMessage } = await apiRequest({
    url: '/banking/expense-categories',
    method: 'post',
    payload: payload
  });
  if (status === constant.Success) {
    await getExpenseCategories()
    return { status };
  }
  return { status, errorMessage };
};

const editExpenseCategories = async (payload, id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/banking/expenseCategory/${id}`,
    method: 'put',
    payload: payload
  });

  if (status === constant.Success) {
    await getExpenseCategories()
    return { status };
  }
  return { status, errorMessage };
};


const deleteExpenseCategories = async (id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/banking/expense-category/${id}`,
    method: 'delete',
  });
  if (status === constant.Success) {
    await getExpenseCategories();
    return { status };
  }
  return { status, errorMessage };
};


export default {
  getExpenseCategories,
  createExpenseCategories,
  editExpenseCategories,
  deleteExpenseCategories,
}
